export const isTouchDevice = 'ontouchstart' in document.documentElement

export const isIos =
  /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

export const createUrl = (base, formData = {}, append = false) => {
  let data = formData

  if (formData instanceof FormData === false) {
    data = new FormData()

    for (const [key, value] of Object.entries(formData)) {
      data.append(key, value)
    }
  }

  if (typeof base === 'object') {
    const baseUrl = new URL(base)

    if (append) {
      const searchParams = baseUrl.searchParams

      const params = {}

      for (const [key, value] of data) {
        const normalizedKey = key.replace('[]', '')

        if (normalizedKey in params) {
          params[normalizedKey].push(value)
        } else {
          params[normalizedKey] = [value]
        }
      }

      for (const [key, value] of Object.entries(params)) {
        const _value = value.filter((x) => x)

        if (_value.length === 0) {
          searchParams.delete(key)
        } else {
          searchParams.set(key, _value.join(','))
        }
      }

      return baseUrl
    } else {
      const params = new URLSearchParams(data)

      return new URL(`${base}?${params}`)
    }
  }

  if (typeof base === 'string') {
    const params = new URLSearchParams(formData)
    const url = new URL(`${base}?${params}`)

    return url
  }
}

export const trackGoogleAnalytics = (event) => {
  if (window.dataLayer) {
    window.dataLayer.push(event)
  }
}
